module.exports = __webpack_public_path__ + "static/media/funktionelles-training-mobile.5029d0a2.jpg";